<template>
  <div class="page">
    <div class="login-hero">
      <div class="section-kicker">WECHAT LOGIN</div>
      <h1>微信一键登录</h1>
      <p>用于获取客户授权昵称，签约后首页“签约人”将显示该昵称。</p>
      <button class="btn light" @click="login" :disabled="loading">{{ loading ? '登录中...' : '微信授权登录' }}</button>
    </div>
    <div class="card login-card">
      <h3>当前登录状态</h3>
      <div class="login-user" v-if="userId">
        <img v-if="avatarUrl" :src="avatarUrl" alt="用户头像">
        <div class="avatar-fallback" v-else>微</div>
        <div>
          <span>已登录用户</span>
          <b>{{ nickname || '微信用户' }}</b>
          <p>用户ID：{{ userId }}</p>
        </div>
      </div>
      <p v-else class="muted">当前未登录，点击上方按钮完成微信授权。</p>
    </div>
  </div>
</template>
<script>
import { ensureLogin } from '../api'
export default {
  data:()=>({loading:false,userId:localStorage.getItem('userId')||'',nickname:localStorage.getItem('nickname')||'',avatarUrl:localStorage.getItem('avatarUrl')||''}),
  methods:{
    async login(){
      this.loading=true
      try{
        const uid=await ensureLogin()
        this.userId=uid || localStorage.getItem('userId') || ''
        this.nickname=localStorage.getItem('nickname') || ''
        this.avatarUrl=localStorage.getItem('avatarUrl') || ''
        if(uid) alert('登录成功')
      }finally{this.loading=false}
    }
  }
}
</script>
<style scoped>
.login-hero{background:linear-gradient(135deg,#123d30,#18b976);color:#fff;border-radius:28px;padding:34px;box-shadow:0 24px 60px rgba(15,118,77,.18);margin-bottom:18px}.login-hero h1{font-size:34px;margin:8px 0}.login-hero p{color:rgba(255,255,255,.82)}.light{background:#fff;color:#0e8d59}.login-user{display:flex;align-items:center;gap:14px}.login-user img,.avatar-fallback{width:58px;height:58px;border-radius:18px;object-fit:cover}.avatar-fallback{display:flex;align-items:center;justify-content:center;background:#e9fbf2;color:#0b935a;font-weight:900}.login-user span{display:block;color:#77827f;font-size:12px}.login-user b{font-size:20px}.login-user p{margin:4px 0 0;color:#77827f}
@media(max-width:768px){.login-hero{padding:22px;border-radius:20px}.login-hero h1{font-size:26px}}
</style>
